import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { LoginComponent } from './login/login.component';
import { MyMaterialModule } from './my-material/my-material.module';
import { RegistrationComponent } from './registration/registration.component';
import { CarouselComponent } from './carousel/carousel.component';
import { AutoRefreshComponent } from './auto-refresh/auto-refresh.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { DetailsComponent } from './details/details.component';
import { ProgressSpinnerComponent } from './shared/progress-spinner.component';
import { LoaderService } from './shared/loader.service';
import { LoaderInterceptorService } from './shared/loader-interceptor.service';
import { DialogOverviewExampleDialog } from './shared/dialog-overview/dailog-overview-example-dialog.component';
// import { DialogOverviewExample } from './shared/dialog-overview/dialog-overview-example.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegistrationComponent,
    CarouselComponent,
    AutoRefreshComponent,
    PasswordResetComponent,
    DetailsComponent,
    ProgressSpinnerComponent,
    DialogOverviewExampleDialog,
    // DialogOverviewExample,
  ],
  imports: [
    BrowserAnimationsModule,
    MyMaterialModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
    }),
  ],
  providers: [
    LoaderService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptorService,
      multi: true,
    },
  ],
   entryComponents: [
    DialogOverviewExampleDialog
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
